import {
  step_spacer_styles_default
} from "./chunk.OO7FD6NE.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  i,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/stepper/step-spacer.ts
var FadvStepSpacer = class extends s {
  constructor() {
    super(...arguments);
    this.orientation = "horizontal";
    this.indicate = false;
  }
  connectedCallback() {
    super.connectedCallback();
    this.handleSiblingResize = this.handleSiblingResize.bind(this);
    if (this.nextElementSibling && this.previousElementSibling) {
      this.resizeObserver = new ResizeObserver(this.handleSiblingResize);
      this.resizeObserver.observe(this.previousElementSibling);
      this.resizeObserver.observe(this.nextElementSibling);
    }
  }
  handleSiblingResize() {
    clearTimeout(this.resizeTimeoutHandle);
    this.resizeTimeoutHandle = setTimeout(() => {
      const previousSibling = this.previousElementSibling;
      const nextSibling = this.nextElementSibling;
      if (this.orientation === "horizontal") {
        this.spacer.style.inset = `0px ${nextSibling.offsetWidth / 2 * -1}px 0px ${previousSibling.offsetWidth / 2 * -1}px`;
      } else {
        this.spacer.style.inset = `${previousSibling.offsetHeight * -1}px 0px 0px`;
      }
    });
  }
  render() {
    return $`<div aria-hidden="true" class=${o({
      "step-spacer": true,
      "step-spacer--indicate": !!this.indicate,
      "step-spacer--vertical": this.orientation === "vertical",
      "step-spacer--horizontal": this.orientation === "horizontal"
    })} ><div class="step-spacer__track"></div></div>`;
  }
};
FadvStepSpacer.styles = step_spacer_styles_default;
__decorateClass([
  e({ reflect: true })
], FadvStepSpacer.prototype, "orientation", 2);
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvStepSpacer.prototype, "indicate", 2);
__decorateClass([
  i(".step-spacer")
], FadvStepSpacer.prototype, "spacer", 2);
FadvStepSpacer = __decorateClass([
  n("fadv-step-spacer")
], FadvStepSpacer);

export {
  FadvStepSpacer
};
